module.exports = __webpack_public_path__ + "static/media/facebook.7ff5140a.svg";